import React from 'react';
// @ts-ignore
import styles from './QuestionnairePreview.module.scss';
import { QuestionnaireItem } from './QuestionnairePreview';
import { QuestionnaireItemType } from '../../Enums/QuestionnaireItemType.enum';
import QuestionnairePreviewQuestion from './Items/QuestionnairePreviewQuestion';
import QuestionnairePreviewAnswer from './Items/QuestionnairePreviewAnswer';
import QuestionnairePreviewOnSubmit from './Items/QuestionnairePreviewOnSubmit';
import Text from '../../../../Components/Base/Text/Text';
import QuestionnairePreviewText from './Items/QuestionnairePreviewText';
import QuestionnairePreviewCollapse from './Items/QuestionnairePreviewCollapse';

export interface QuestionnairePreviewItem {
	item: QuestionnaireItem;
}

const QuestionnairePreviewItem: React.FC<QuestionnairePreviewItem> = ({
	item,
}) => {
	let component;

	switch (item.type) {
		case QuestionnaireItemType.QUESTION:
		case QuestionnaireItemType.ITEM:
			component = <QuestionnairePreviewQuestion item={item} />;
			break;
		case QuestionnaireItemType.ANSWER:
			component = <QuestionnairePreviewAnswer item={item} />;
			break;
		case QuestionnaireItemType.ON_SUBMIT:
			component = <QuestionnairePreviewOnSubmit item={item} />;
			break;
		case QuestionnaireItemType.TEXT:
			component = <QuestionnairePreviewText item={item} />;
			break;
		case QuestionnaireItemType.COLLAPSE:
			component = <QuestionnairePreviewCollapse item={item} />;
			break;
		default:
			component = <Text tx='component.questionnairePreview.unsupportedItem' />;
			break;
	}

	return <div className={styles.item}>{component}</div>;
};

export default QuestionnairePreviewItem;
